export const en = {
  common: {
    loading: 'Loading...',
    cancel: 'Cancel',
    save: 'Save',
    close: 'Close',
    submit: 'Submit',
    error: 'Error occurred',
    success: 'Success',
    confirm: 'Confirm',
    actions: 'Actions',
    notes: 'Notes',
    unknown: 'Unknown',
    na: 'N/A',
    viewDetails: 'View Details',
    accessDenied: 'Access Denied',
    adminRequired: 'Admin privileges required.',
    delete: 'Delete',
    edit: 'Edit',
    request: 'Request',
    status: 'Status',
    user: 'User',
    quantity: 'Quantity',
    date: 'Date',
    reason: 'Reason',
    role: 'Role',
    item: 'Item',
    name: 'Name',
    location: 'Location',
    tags: 'Tags',
    description: 'Description',
    category: 'Category',
    categoryPlaceholder: 'Select a category...',
    locationPlaceholder: 'Select a location...',
    groupId: 'Group ID / Product SKU (Optional)',
    groupIdHelp: 'Use the same ID for identical items in different locations to group them on dashboard.',
    imageUrl: 'Image URL (optional)',
    created: 'Created',
    email: 'Email',
    itemName: 'Item Name',
    expectedReturnDate: 'Expected Return Date',
    notesOptional: 'Notes (optional)',
    roles: {
      admin: 'Administrator',
      keeper: 'Keeper',
      user: 'User',
    },
    statuses: {
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      returned: 'Returned',
      available: 'Available',
      on_loan: 'On Loan',
      low_stock: 'Low Stock',
      out_of_stock: 'Out of Stock',
      maintenance: 'Maintenance',
      retired: 'Retired',
    }
  },
  auth: {
    signIn: 'Sign in with Google',
    signingIn: 'Signing in...',
    signOut: 'Sign out',
    failedSignIn: 'Failed to sign in. Please try again.',
    failedSignOut: 'Failed to sign out. Please try again.',
    loginError: 'Sign-in Failed',
    troubleshooting: 'View Troubleshooting Guide',
    roleRequestSubmitted: 'Role request submitted successfully! An admin will review your request.',
    roleRequestFailed: 'Failed to submit request. Please try again.',
    popupClosed: 'Sign-in cancelled. Please try again.',
    popupBlocked: 'Popup blocked. Please allow popups for this site.',
    domainUnauthorized: 'Domain not authorized. Please check Firebase settings.',
    invalidApiKey: 'Invalid Firebase API key. Please check your .env file.',
    firestoreError: 'Authentication successful but database connection failed. Please check Firestore configuration.',
    timeout: 'Authentication timeout - Firestore may not be configured',
    requestRoleChange: 'Request Role Change',
    selectRoleDescription: 'Select a role to request access.',
    selectRolePlaceholder: 'Select a role...',
    roleHistory: 'Role History',
    language: 'Language',
    selectLanguage: 'Select Language',
    languages: {
      en: 'English',
      hu: 'Hungarian',
    },
  },
  nav: {
    dashboard: 'Dashboard',
    admin: 'Admin Panel',
    myLoans: 'My Loans',
    settings: 'Settings',
    profile: 'Profile',
  },
  dashboard: {
    title: 'Inventory Dashboard',
    addItem: 'Add Item',
    searchPlaceholder: 'Search items by name, description, or tags...',
    allStatus: 'All Status',
    allLocations: 'All Locations',
    groupProducts: 'Group Products',
    noItems: 'No items found',
    available: 'Available',
    onLoan: 'On Loan',
    maintenance: 'Maintenance',
    retired: 'Retired',
    requestItem: 'Request Item',
    expectedReturnDate: 'Expected Return Date',
    itemLoanHistory: 'Item Loan History',
    productDetails: 'Product Details',
    inventoryBreakdown: 'Inventory Breakdown',
    activeLoansSummary: 'Active Loans Summary',
    total: 'Total',
    grouped: 'Grouped',
    deleteConfirm: 'Are you sure you want to delete this item?',
    itemDeleted: 'Item deleted successfully',
    itemSaved: 'Item saved successfully',
    requestSubmitted: 'Request submitted successfully!',
    loginRequired: 'You must be logged in to request items',
    selectDate: 'Please select an expected return date',
    invalidDate: 'Invalid return date',
    futureDate: 'Return date must be in the future',
    requested: 'Requested',
    returned: 'Returned',
    lowStock: 'Low Stock',
    outOfStock: 'Out of Stock',
  },
  admin: {
    title: 'Admin Panel',
    pendingRequests: 'Pending Requests',
    activeLoans: 'Active Loans',
    returnedLoans: 'Returned Loans',
    roleRequests: 'Role Requests',
    userManagement: 'User Management',
    noPending: 'No pending requests at this time.',
    noActive: 'No active loans at this time.',
    noReturned: 'No returned loans yet.',
    noRoleRequests: 'No pending role requests.',
    approve: 'Approve',
    reject: 'Reject',
    markReturned: 'Mark Returned',
    daysOut: 'days out',
    overdue: 'OVERDUE',
    wasOverdue: 'Was Overdue',
    rejectLoan: 'Reject Loan Request',
    rejectReason: 'Reason for Rejection (Optional)',
    confirmReject: 'Confirm Rejection',
    rejectWarning: 'This action cannot be undone. The user will be notified of the rejection.',
    loanApproved: 'Loan request approved successfully!',
    loanRejected: 'Loan request rejected.',
    itemReturned: 'Item marked as returned!',
    roleApproved: 'Role request approved successfully!',
    roleRejected: 'Role request rejected.',
    confirmRoleChange: 'Are you sure you want to change this user\'s role to',
    roleUpdated: 'User role updated to',
    requestedBy: 'Requested By',
    requestedDate: 'Requested Date',
    borrowedBy: 'Borrowed By',
    approvedDate: 'Approved Date',
    duration: 'Duration',
    currentRole: 'Current Role',
    requestedRole: 'Requested Role',
    changeRole: 'Change Role',
  },
  myLoans: {
    title: 'My Loans',
    subtitle: 'Track your borrowed items and request history',
    currentLoans: 'Current Loans',
    loanHistory: 'Loan History',
    noCurrent: 'No active loans.',
    noHistory: 'No loan history.',
    awaitingApproval: 'Awaiting approval',
    currentlyBorrowed: 'Currently borrowed',
    completedLoans: 'Completed loans',
    status: {
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      returned: 'Returned',
    }
  },
  settings: {
    title: 'Settings',
    locations: 'Locations',
    categories: 'Categories',
    addLocation: 'Add Location',
    addCategory: 'Add Category',
    locationName: 'Location Name',
    categoryName: 'Category Name',
    deleteConfirm: 'Are you sure you want to delete this?',
    saved: 'Saved successfully',
    deleted: 'Deleted successfully',
    manageLocations: 'Manage Locations',
    manageCategories: 'Manage Categories',
    active: 'Active',
    inactive: 'Inactive',
    locationDescription: 'Location Description (optional)',
    categoryDescription: 'Category Description (optional)',
  }
};
